export class EntitlementBlockedError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'EntitlementBlockedError';
    }
}

export const isEntitlementBlockedError = (error: unknown): error is EntitlementBlockedError =>
    error instanceof EntitlementBlockedError;
